module.exports = "/virtual-football-league/img/jerseys/White.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/jerseys/White.png
// module id = 2243
// module chunks = 4